module.exports = __webpack_public_path__ + "winner-badge-team-3.dcaaf4d9ed4d2553e48c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/winner-badge-team-3.svg
// module id = ./src/assets/svgs/winner-badge-team-3.svg
// module chunks = main